import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

export default function TabBodyContainer({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="flex-1 flex flex-col items-center"
    >
      {value === index && (
        <Box className="w-full flex-1 flex p-0">
          <div className="flex-1 overflow-y-auto w-full h-full">{children}</div>
        </Box>
      )}
    </div>
  );
}

TabBodyContainer.propTypes = {
  children: PropTypes.any,
  value: PropTypes.number,
  index: PropTypes.number,
};
